<template>
  <div class="custom-page-box">
    <a-card title="成员分组" :bordered="false" :headStyle="{fontSize:'18px'}">
      <a-input-search placeholder="请输入分组名称" @search="onSearch" style="max-width: 400px;"/>
      <a-button style="margin-left: 20px" type="primary" @click="createGroupEvent">创建分组</a-button>
      <custom-paging-dragging-list
        style="margin-top: 20px;"
        ref="pageList"
        rowKey="id"
        :columns="columns"
        :queryParams="queryParams"
        :requestPromise="loadPromise"
        @draggable="onDraggable"
      >
        <span slot="action" slot-scope="data">
          <a @click="editEvent(data.record)">编辑</a>
          <a-divider type="vertical"></a-divider>
          <a-popconfirm
            title="是否要删除当前分组？"
            @confirm="deleteEvent(data.record)">
              <a>删除</a>
          </a-popconfirm>
      </span>
      </custom-paging-dragging-list>
    </a-card>
  </div>
</template>

<script>
import searchForm from '../../../utils/mixins/searchFormMixins'
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'GroupList',
  mixins: [searchForm],
  components: {
    CustomPagingDraggingList
  },
  data() {
    return {
      queryParams: {},
      loadPromise: params => this.getGroupListPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '分组名称',
          dataIndex: 'name'
        },
        {
          title: '成员数量',
          dataIndex: 'staffCount'
        },
        {
          title: '分组类型',
          dataIndex: 'catalogStr'
        },
        {
          title: '打标规则',
          dataIndex: 'flagRule'
        },
        {
          title: '优先级',
          dataIndex: 'sort'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadCount: 0
    }
  },
  mounted() {
    this.loadCount = 1
  },

  activated() {
    this.loadCount = this.loadCount + 1
    if (this.loadCount > 2) {
      this.$refs.pageList.refresh()
    }
  },
  methods: {
    // 拖拽排序功能
    onDraggable(params) {
      this.getLogUtils().logWithTag('==onDraggable排序==', params)
      let idList = new Array
      idList = params.dataList.map((item) => {
        return item.id
      })
      this.getLogUtils().logWithTag('==idList==', idList)
      this.getHttpServices().getUserService().post('merchant/v2/group/updateGroupSort', {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList
      }).then(res => {
        this.getLogUtils().logWithTag('==onDraggable==', res)
        this.$message.success('排序成功')
        this.$refs.pageList.refresh()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getGroupListPromise(params) {
      this.getLogUtils().logWithTag('====params======', params)
      return this.getHttpServices().getUserService().post('merchant/v2/group/getGroupList', params)
    },
    onSearch(value) {
      this.queryParams.name = value
      this.$refs.pageList.refresh(true)
    },
    createGroupEvent() {
      this.openNewPage('GroupCreator', {})
    },
    deleteEvent(record) {
      return this.getHttpServices().getUserService().post('merchant/v2/group/deleteGroup', { id: record.id }).then(res => {
        this.$message.success('删除成功')
        this.$refs.pageList.refresh()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    editEvent(record) {
      this.openNewPage('GroupEditor', { id: record.id })
    }
  }

}
</script>
<style lang="less">
@import "../../CustomPage";
</style>
<style lang="less">
.table-default-item {

  &:nth-child(6) {
    text-align: center;
  }
}
</style>